<div [class]="'rounded-2xl p-5 ' + theme.current.boxed">
    <app-wysiwyg [theme]="theme" [block]="block"></app-wysiwyg>
</div>
